import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div
                className="min-h-screen bg-obsidian flex items-center justify-center"
                data-testid="auth-checking"
            >
                <Loader2 className="w-6 h-6 text-blaze animate-spin" />
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    return children;
};
